import React from 'react';
import { Link } from 'react-router-dom';
import logo from "../img/logoAcs2.png";

const Navbar = ({ nomeUsuario, onLogout }) => {
  return (
    <nav className="bg-white shadow-md w-full mb-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 py-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 sm:gap-0">

        {/* 🔹 Seção do logo + nome do usuário */}
        <div className="flex flex-col sm:flex-row items-center sm:items-center text-center sm:text-left gap-3">
          {/* Logo */}
          <img
            src={logo}
            alt="Logo"
            className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
          />

          {/* Nome do líder */}
          <div>
            <span className="text-gray-600">Líder da Equipe:</span>
            <span className="font-bold text-gray-800 ml-2 block sm:inline">
              {nomeUsuario || 'Carregando...'}
            </span>
          </div>
        </div>

        {/* 🔹 Seção dos botões */}
        <div className="flex items-center justify-center sm:justify-end gap-4">
          <Link
            to="/perfil"
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 whitespace-nowrap"
          >
            Editar Perfil
          </Link>
          <button
            onClick={onLogout}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 whitespace-nowrap"
          >
            Sair
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
